import { SubscriptionTier } from 'types';
import formatTierQuantity from './formatTierQuantity';

export type UsageLimit = number | 'Unlimited';

export default function getFlatTierLimit(
    tiers: SubscriptionTier[] | undefined,
    unit: string,
): UsageLimit | null {
    if (!tiers?.length) {
        return null;
    }

    const { up_to: upTo } = tiers[0];

    if (upTo == null) {
        return tiers.length === 1 ? 'Unlimited' : null;
    }

    return formatTierQuantity(upTo, unit);
}
